/**
 * VENDOR MODULES
 */
import React from 'react';
import i18n  from "i18n";

import { FINAL_OUTCOME_NAMES } from 'shared/constants/baseball-markets';
import GridOdd from 'shared/components/outcomes/grids/GridOdd';
import { vsOutcomeTypeKey } from 'lib/virtualSportsI18n';
import { baseballFinalOutcomePitchesOutcomeTypeId, baseballFinalOutcomeOutcomeTypeId } from 'lib/virtualSportsOutcomeIds';

/**
 * Renders the lists of combinations for final outcomes and number of pitches
 *
 * @class  FinalAndPitches (name)
 * @param  {<type>}   props The properties
 * @return {boolean}  { description_of_the_return_value }
 */
function FinalAndPitches(props) {
  const {
    outcomes,
  } = props

  const final_and_pitches = Object.values(outcomes)
    .filter(x => parseInt(x.market_type_id) === 4003)
    .slice()
    .sort((a, b) => Number(a.outcome_type_id) - Number(b.outcome_type_id));
  const final_and_pitches_rows = FINAL_OUTCOME_NAMES
    .sort((a, b) => a.localeCompare(b))
    .map((outcome_name, rowIndex) => {
      let combos = [];
      for (var i = 1; i <= 7; i++) {
        let match = {};
        try {
          const outcomeTypeId = baseballFinalOutcomePitchesOutcomeTypeId({ finalOutcome: outcome_name, pitchN: i });
          match = final_and_pitches.find((x) => String(x.outcome_type_id) === outcomeTypeId) || {};
        } catch (e) {
          match = {};
        }
        combos.push(
          <td key={i} className="p-0">
            <GridOdd
              {...{
                ...match,
                class_names: ['grid-odd-baseball', 'outcome-4003', 'bg-background/80', 'px-1', 'py-0.5', 'text-xs', 'h-8', 'w-full'],
                market_type_group_id: 403
              }}
            />
          </td>
        );
      }
      return (
        <tr key={rowIndex} className="border-b border-border">
          <td
            className="sticky left-0 z-10 w-[120px] min-w-[120px] max-w-[120px] px-2 py-2"
            style={{ backgroundColor: 'hsl(var(--card))' }}
          >
            <span className="text-xs text-foreground font-medium whitespace-nowrap">
              {i18n.t(vsOutcomeTypeKey(baseballFinalOutcomeOutcomeTypeId(outcome_name), false))}
            </span>
          </td>
          {combos}
        </tr>
      );
    });

  return (
    <>
      <div className="overflow-x-auto overflow-y-visible [scrollbar-width:thin]">
        <table className="w-full min-w-max table-fixed border-separate [border-spacing:2px_0]">
          <thead>
            <tr>
              <th
                className="sticky left-0 z-20 w-[120px] min-w-[120px] max-w-[120px] px-2 py-2 text-left text-xs font-semibold border-b border-border"
                style={{ backgroundColor: 'hsl(var(--card))' }}
              />
              {[1, 2, 3, 4, 5, 6, 7].map((n) => (
                <th
                  key={n}
                  className="px-2 py-2 text-center text-xs font-semibold border-b border-border bg-muted/40 text-foreground"
                  style={{ minWidth: '55px', width: '55px' }}
                >
                  {n}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {final_and_pitches_rows}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default FinalAndPitches;

